import { popConnect2DSelection } from '@features/analysis/rendering/Panels/Renderers/CornerstoneManager';
import { useCallback, useEffect, useState } from 'react';
import {
  getCprBoundaryEditHistoryStatus,
  redoCprBoundaryEdit,
  subscribeCprBoundaryEditHistory,
  undoCprBoundaryEdit,
} from 'utils/CPRUtilities/cprBoundaryEditHistory';

export function useCprModificationHistoryStatus({
  isSelectedCprPanel,
  isSelectedSegmentHistoryPanel,
  undoable,
  redoable,
  undoStroke,
  redoStroke,
}: {
  isSelectedCprPanel: boolean;
  isSelectedSegmentHistoryPanel: boolean;
  undoable: boolean;
  redoable: boolean;
  undoStroke: () => void;
  redoStroke: () => void;
}) {
  const [cprHistoryStatus, setCprHistoryStatus] = useState(
    getCprBoundaryEditHistoryStatus,
  );

  useEffect(() => {
    const syncCprHistoryStatus = () => {
      setCprHistoryStatus(getCprBoundaryEditHistoryStatus());
    };
    syncCprHistoryStatus();
    return subscribeCprBoundaryEditHistory(syncCprHistoryStatus);
  }, []);

  const canUndoSegmentHistory = isSelectedSegmentHistoryPanel && undoable;
  const canRedoSegmentHistory = isSelectedSegmentHistoryPanel && redoable;
  const canUndoSelectedModification =
    canUndoSegmentHistory || (isSelectedCprPanel && cprHistoryStatus.canUndo);
  const canRedoSelectedModification =
    canRedoSegmentHistory || (isSelectedCprPanel && cprHistoryStatus.canRedo);

  const handleUndoSelectedModification = useCallback(() => {
    if (canUndoSegmentHistory) {
      popConnect2DSelection();
      undoStroke();
      return;
    }
    if (isSelectedCprPanel) {
      undoCprBoundaryEdit();
    }
  }, [canUndoSegmentHistory, isSelectedCprPanel, undoStroke]);

  const handleRedoSelectedModification = useCallback(() => {
    if (canRedoSegmentHistory) {
      redoStroke();
      return;
    }
    if (isSelectedCprPanel) {
      redoCprBoundaryEdit();
    }
  }, [canRedoSegmentHistory, isSelectedCprPanel, redoStroke]);

  return {
    cprHistoryStatus,
    canUndoSelectedModification,
    canRedoSelectedModification,
    handleUndoSelectedModification,
    handleRedoSelectedModification,
  };
}
